import { zesaTariffBands, REA } from "./zesa_bands.js"; //Enforce single source of truth rule
function prepareResultsTable(priorUnits, wantedUnits) {
  let startBand = 1;
  let ourREA = REA;
  let combinedTariff = ourREA + 1;
  let startUnits = priorUnits;
  let wantedUnitsBands = [0, 0, 0, 0, 0, 0];
  let unitsToBuy = wantedUnits;
  let unitsPerBand = [
    zesaTariffBands.first50.bandUnits,
    zesaTariffBands.secondBand.bandUnits,
    zesaTariffBands.thirdBand.bandUnits,
    zesaTariffBands.fourthBand.bandUnits,
    zesaTariffBands.fifthBand.bandUnits,
    zesaTariffBands.finalBand.bandUnits,
  ];
  let bandOriginalAllocations = [
    zesaTariffBands.first50.bandUnits,
    zesaTariffBands.secondBand.bandUnits,
    zesaTariffBands.thirdBand.bandUnits,
    zesaTariffBands.fourthBand.bandUnits,
    zesaTariffBands.fifthBand.bandUnits,
  ].map((element) => Number(element)); //Make sure we have numbers in there
  let remainingBUnits = bandOriginalAllocations;
  let correspondingBandTariffs = [
    zesaTariffBands.first50.tariff * combinedTariff,
    zesaTariffBands.secondBand.tariff * combinedTariff,
    zesaTariffBands.thirdBand.tariff * combinedTariff,
    zesaTariffBands.fourthBand.tariff * combinedTariff,
    zesaTariffBands.fifthBand.tariff * combinedTariff,
    zesaTariffBands.finalBand.tariff * combinedTariff,
  ];
  let tariffsArray = [
    zesaTariffBands.first50.tariff,
    zesaTariffBands.secondBand.tariff,
    zesaTariffBands.thirdBand.tariff,
    zesaTariffBands.fourthBand.tariff,
    zesaTariffBands.fifthBand.tariff,
    zesaTariffBands.finalBand.tariff,
  ];
  let reaCentsTariff = correspondingBandTariffs.map((item, index) => {
    return item - tariffsArray[index];
  });

  //First band allocation
  if ((startUnits > 0) & (startUnits <= zesaTariffBands.first50.bandUnits)) {
    remainingBUnits[0] -= startUnits;
    startUnits = 0;
    //start band is still 1 do nothing
  } else if (startUnits > zesaTariffBands.first50.bandUnits) {
    remainingBUnits[0] -= zesaTariffBands.first50.bandUnits; //Customer exhausted first band
    startUnits -= zesaTariffBands.first50.bandUnits;
    //Change the start band to second
    startBand = 2;
  }
  //Do second Band
  if (startUnits < zesaTariffBands.secondBand.bandUnits) {
    remainingBUnits[1] -= startUnits;
    startUnits = 0;
  } else if (startUnits >= zesaTariffBands.secondBand.bandUnits) {
    remainingBUnits[1] -= zesaTariffBands.secondBand.bandUnits;
    startUnits -= zesaTariffBands.secondBand.bandUnits;
    startBand = 3;
  }
  //Do third Band
  if (startUnits < zesaTariffBands.thirdBand.bandUnits) {
    remainingBUnits[2] -= startUnits;
    startUnits = 0;
  } else if (startUnits >= zesaTariffBands.thirdBand.bandUnits) {
    remainingBUnits[2] -= zesaTariffBands.thirdBand.bandUnits;
    startUnits -= zesaTariffBands.thirdBand.bandUnits;
    startBand = 4;
  }
  //do fourth band
  if (startUnits < zesaTariffBands.fourthBand.bandUnits) {
    remainingBUnits[3] -= startUnits;
    startUnits = 0;
  } else if (startUnits >= zesaTariffBands.fourthBand.bandUnits) {
    remainingBUnits[3] -= zesaTariffBands.fourthBand.bandUnits;
    startUnits -= zesaTariffBands.fourthBand.bandUnits;
    startBand = 5;
  }
  //Do fifth band
  if (startUnits < zesaTariffBands.fifthBand.bandUnits) {
    remainingBUnits[4] -= startUnits;
    startUnits = 0;
  } else if (startUnits >= zesaTariffBands.fifthBand.bandUnits) {
    remainingBUnits[4] -= zesaTariffBands.fifthBand.bandUnits;
    startUnits -= zesaTariffBands.fifthBand.bandUnits;
    startBand = 6; //Customer exhausted their subsidised units
  }

  //Now apportion wanted Units
  //Let's do first band
  if ((remainingBUnits[0] > 0) & (startBand === 1) & (unitsToBuy > 0)) {
    //if we have enough units let's end here

    if (unitsToBuy <= remainingBUnits[0]) {
      wantedUnitsBands[0] = unitsToBuy;
      unitsToBuy = 0;
    } else if (unitsToBuy > remainingBUnits[0]) {
      //we dont have enough units let deduct what we have in this band and move to the next one

      wantedUnitsBands[0] = remainingBUnits[0];
      unitsToBuy -= remainingBUnits[0];
      startBand = 2;
    }
  }

  if ((remainingBUnits[1] > 0) & (startBand === 2) & (unitsToBuy > 0)) {
    //We have enought units in the second band

    if (unitsToBuy <= remainingBUnits[1]) {
      wantedUnitsBands[1] = unitsToBuy;
      unitsToBuy = 0;
    } else if (unitsToBuy > remainingBUnits[1]) {
      //We don't have enough units move deduct remaining units in band and move up to other band

      wantedUnitsBands[1] = remainingBUnits[1];
      unitsToBuy -= remainingBUnits[1];
      startBand = 3;
    }
  }

  if ((remainingBUnits[2] > 0) & (startBand === 3) & (unitsToBuy > 0)) {
    //We have enought units in the second band

    if (unitsToBuy <= remainingBUnits[2]) {
      wantedUnitsBands[2] = unitsToBuy;
      unitsToBuy = 0;
    } else if (unitsToBuy > remainingBUnits[2]) {
      //We don't have enough units move deduct remaining units in band and move up to other band
      wantedUnitsBands[2] = remainingBUnits[2];
      unitsToBuy -= remainingBUnits[2];
      startBand = 4;
    }
  }
  if ((remainingBUnits[3] > 0) & (startBand === 4) & (unitsToBuy > 0)) {
    //We have enought units in the second band

    if (unitsToBuy <= remainingBUnits[3]) {
      wantedUnitsBands[3] = unitsToBuy;
      unitsToBuy = 0;
    } else if (unitsToBuy > remainingBUnits[3]) {
      //We don't have enough units move deduct remaining units in band and move up to other band
      wantedUnitsBands[3] = remainingBUnits[3];
      unitsToBuy -= remainingBUnits[3];
      startBand = 5;
    }
  }
  if ((remainingBUnits[4] > 0) & (startBand === 5) & (unitsToBuy > 0)) {
    //We have enought units in the second band

    if (unitsToBuy <= remainingBUnits[4]) {
      wantedUnitsBands[4] = unitsToBuy;
      unitsToBuy = 0;
    } else if (unitsToBuy > remainingBUnits[4]) {
      //We don't have enough units move deduct remaining units in band and move up to other band
      wantedUnitsBands[4] = remainingBUnits[4];
      unitsToBuy -= remainingBUnits[4];
      startBand = 6;
    }
  }
  if (unitsToBuy > 0) {
    //Buyer has gone over subsidised bands
    wantedUnitsBands[5] = unitsToBuy;
  }

  //Let's create the REA column
  let reaZWLColumn = reaCentsTariff.map((item, index) => {
    return Number((item * wantedUnitsBands[index]).toFixed(2));
  });
  let netEnergyColumn = wantedUnitsBands.map((item, index) => {
    return tariffsArray[index] * item;
  });
  let totalChargeColumn = wantedUnitsBands.map((item, index) => {
    return Number((correspondingBandTariffs[index] * item).toFixed(2));
  });
  //Add infinity symbol to sixth/final band
  bandOriginalAllocations[5] = "∞";
  //Now lets create the data
  let tableDataArray = [];
  for (let index = 0; index < 6; index++) {
    tableDataArray.push([
      index + 1,
      unitsPerBand[index],
      tariffsArray[index],
      netEnergyColumn[index] !== 0 ? netEnergyColumn[index].toFixed(2) : "-",

      reaZWLColumn[index] != 0 ? reaZWLColumn[index].toFixed(2) : "-",
      totalChargeColumn[index] != 0 ? totalChargeColumn[index].toFixed(2) : "-",
      wantedUnitsBands[index] != 0 ? wantedUnitsBands[index].toFixed(2) : "-",
    ]);
  }

  //Add total row
  tableDataArray.push([
    "Total",
    "-",
    "-",
    netEnergyColumn.reduce((a, b) => a + b, 0).toFixed(2),
    Number(reaZWLColumn.reduce((a, b) => a + b, 0).toFixed(2)),
    totalChargeColumn.reduce((a, b) => a + b, 0).toFixed(2),
    wantedUnitsBands.reduce((a, b) => a + b, 0).toFixed(2),
  ]);
  return tableDataArray;
}
export { prepareResultsTable };
